// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-11PzX","extrasBanner":"extrasBanner-eS3R3","content":"content-1pZma"};